const checkIsEventDay = (metadata, date) => {
  if (metadata?.doubleDate?.includes(date)) {
    return {
      text: 'Double Date',
      bgColor: 'var(--color-primary40)',
    };
  } else if (metadata?.paydayDate?.includes(date)) {
    return {
      text: 'Pay Day',
      bgColor: 'var(--color-error30)',
    };
  } else if (metadata?.peakDayDate?.includes(date)) {
    return {
      text: 'Peak Day',
      bgColor: 'var(--color-success50)',
    };
  }

  return null;
};

export default checkIsEventDay;
